export const SET_PREFERENCES = "setPreferences";

export const setPreferences = (payload: any) => {
  return {
    type: SET_PREFERENCES,
    payload,
  };
};
